import React from "react"

import {User as ItemType} from "../../types/User"

import ViewHeader           from "./View/Header"
import ViewItemGroupInfo    from "./View/ItemGroupInfo"
import ViewItemDataSource   from "./View/ItemGroupDataSource";
import ViewItemGroupAccount from "./View/ItemGroupAccount";
import ViewItemGroupLinked from "./View/ItemGroupLinked";

export interface formProps {
    item: ItemType
}

const View: React.FC<formProps> = ({ item }) => {

    return (
        <div className="ion-text-center">
            <ViewHeader        item={item} />
            <ViewItemGroupInfo item={item} />
            {(item.dataSourceId && item.sourceItemId) &&
                <ViewItemDataSource item={item} />
            }
            {item.isAdmin && <ViewItemGroupAccount item={item} />}
            {! item.isAdmin && <ViewItemGroupLinked item={item} />}
        </div>
    )
}

export default View